export const options = {
  background: {
    color: '#F4F4F5'
  },
  autoResize: true,
  translating: {
    restrict: true
  },
  panning: {
    enabled: true,
    // modifiers: ['ctrl', 'shift'],
    eventTypes: ['rightMouseDown']
  },
  async: true,
  allowLoop: false,
  mousewheel: true,
  selection: true,
  highlighting: {
    magnetAdsorbed: {
      name: 'stroke',
      args: {
        attrs: {
          'stroke-width': 0
        }
      }
    }
  },
  keyboard: {
    enabled: true
  }
}
